module.exports = __webpack_public_path__ + "static/media/soundbody_demo.a8474f17.gif";